"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapHandshakeProjectStatus = mapHandshakeProjectStatus;
exports.casetrustProjectStatusLabel = casetrustProjectStatusLabel;
function mapHandshakeProjectStatus(status) {
    if (status === "completed")
        return "completed";
    if (status === "disputing")
        return "in-dispute";
    return "in-progress";
}
function casetrustProjectStatusLabel(status) {
    if (status === "completed")
        return "Completed";
    if (status === "in-dispute")
        return "In dispute";
    return "In progress";
}
